import script from "./SectionLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionLayout.vue?vue&type=script&setup=true&lang=js"

import "./SectionLayout.vue?vue&type=style&index=0&id=404fb054&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-404fb054"]])

export default __exports__